import { motion } from "motion/react";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import { useRtl } from "@ryde/redux";
import { COLLAPSE_DURATION_SEC, onActivateKeyDown } from "@ryde/shared";

import { RideTabsBottomExpandToggleStyled } from "./ride-tabs-bottom-blocks.styled";

const MotionArrowStatExpand = motion.create(SVG_MUI.ArrowStatExpand3SVG);

interface IRideTabsBottomBlocksExpandToggleProps {
  isExpanded: boolean;
  onToggle: () => void;
}

export const RideTabsBottomBlocksExpandToggle: FC<
  IRideTabsBottomBlocksExpandToggleProps
> = ({ isExpanded, onToggle }) => {
  const { t } = useTranslation();
  const { isRtl } = useRtl();

  const collapsedRotation = isRtl ? 180 : 0;

  return (
    <RideTabsBottomExpandToggleStyled
      aria-expanded={isExpanded}
      aria-label={
        isExpanded
          ? t("ride.bottomBlocks.collapseDetails", {
              defaultValue: "Hide ride details",
            })
          : t("ride.bottomBlocks.expandDetails", {
              defaultValue: "Show ride details",
            })
      }
      onClick={onToggle}
      onKeyDown={onActivateKeyDown(onToggle)}
    >
      <MotionArrowStatExpand
        animate={{ rotate: isExpanded ? 90 : collapsedRotation }}
        transition={{ duration: COLLAPSE_DURATION_SEC }}
      />
    </RideTabsBottomExpandToggleStyled>
  );
};
